import { inject } from '@angular/core';
import type { ApolloLink, DefaultContext, TypedDocumentNode } from '@apollo/client/core';
import { Apollo } from 'apollo-angular';
import type { Observable } from 'rxjs';

/**
 * static-graphql-documents (D3): typed from the passed `TypedDocumentNode` —
 * see `mutate-create.ts` for the generic-defaults rationale.
 */
export function mutateDeleteById<
  TData extends object = Record<string, unknown>,
  TVariables extends { id: unknown } = { id: string },
>(
  mutation: TypedDocumentNode<TData, TVariables>,
  id: TVariables['id'],
  headers?: Record<string, string>,
): Observable<ApolloLink.Result<TData>> {
  const apollo = inject(Apollo);
  return apollo.mutate<TData, TVariables>({
    mutation,
    variables: { id } as TVariables,
    context: { headers } as DefaultContext,
  });
}
